const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const loopMap = require('mn-utils/loopMap');
const map = require('mn-utils/map');
const {
  apiRequest,
} = require('../ws');
const {
  DEFAULT_CURRENCY,
} = require('../../constants');

export const DEFAULT_CASH = {
  asset_code: DEFAULT_CURRENCY,
  total: '0.00',
  available: '0.00',
  pending: '0.00',
};

const mockCash$ = new Emitter(1354.0990);
const withdraws$ = new Emitter(loopMap(55, (i) => {
  const si = i % 3;
  return {
    id: 1 + i,
    time: new Date('2020-02-17T12:07'),
    bank_name: 'Berliner Sparkasse',
    status: si == 0
      ? 'Processing'
      : si == 1 ? 'Done' : 'Error',
    amount: 200,
  };
}));

export function apiBankName() {
  return process.env.MOCK
    ? CancelablePromise.delay(500, {
      name: 'Sparkasse',
    })
    : apiRequest('/v1/console/bank/name');
}
export function apiCashFee() {
  return process.env.MOCK
    ? CancelablePromise.delay(500, {
      fee: 1,
    })
    : apiRequest('/v1/console/cash/fee');
}
export function apiCashAmount() {
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      ...DEFAULT_CASH,
      asset_code: DEFAULT_CURRENCY,
      total: mockCash$.getValue(),
    });
  }
  return apiRequest('/v1/console/assets/amount');
}

export function apiWithdraw(params) {
  params = params || {};
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {}).then(() => {
      const date = new Date();
      withdraws$.emit([
        {
          id: date.getTime(),
          time: date,
          bank_name: 'Berliner Sparkasse',
          status: 'Processing',
          amount: mockCash$.getValue(),
        },
        ...withdraws$.getValue(),
      ]);
      mockCash$.emit(0);
    });
  }

  return apiRequest('/v1/console/withdraw/available', params);
}
